import noInputFlowsSvg from "../assets/noContentPlaceholders/noInputFlows.svg";
import {Col} from "reactstrap";
import React, {CSSProperties} from "react";
import styles from './NoContentAvailable.module.scss';


type NoContentAvailableProps = {
  image?: string,
  title?: string | JSX.Element,
  subtitle?: string | JSX.Element,
  actions?: JSX.Element,
  className?: string,
  style?: CSSProperties
}


export default function NoContentAvailable({
                                             image,
                                             title,
                                             subtitle,
                                             actions,
                                             className,
                                             style,
                                           }: NoContentAvailableProps): JSX.Element {
  return <Col className={`d-flex d-column justify-content-center align-items-center ${className}`} style={style}>
    <div className={styles.wrapper}>
      <img src={image || noInputFlowsSvg} alt=""/>
      {title && typeof title === "string" ?
        <h2 className={styles.title}>
          {title}
        </h2> : title}
      {subtitle && typeof subtitle === "string" ?
        <p className={styles.subtitle}>
          {subtitle}
        </p> : subtitle}
      {actions && actions}
    </div>
  </Col>
}

export const noContentStyles = styles;
